import React from 'react';
import { useTranslation } from 'react-i18next';


const YesNoQuestion = ({ question, handleAnswer, answerStatus }) => {
    const { t } = useTranslation(); // Zde se destrukturalizuje `t`

    return (
        <div className="answerInputs">
            <button 
                onClick={() => handleAnswer(true)}
                className={answerStatus ? (question.correctAnswer ? 'btn-green' : 'btn-red') : 'btn-secondary'}>
                {t('yes')}
            </button>
            <button 
                onClick={() => handleAnswer(false)}
                className={answerStatus ? (!question.correctAnswer ? 'btn-green' : 'btn-red') : 'btn-secondary'}>
                {t('no')}
            </button>
        </div>
    );
};

export default YesNoQuestion;
